export default __webpack_public_path__ + "static/media/spokenWave2.05fb3f1b.png";